import React from 'react';

const Terms = () => {
    return (
        <section style={{ padding: "2%" }}>
            <h1 id="title">リリースノート</h1>
            <table>
                <tbody>
                    <tr>
                        <td><h3>ver 1.0.1</h3></td>
                    </tr>
                    <tr>
                        <td>軽微な修正をしました。</td>
                    </tr>
                    <tr>
                        <td><br /></td>
                    </tr>
                </tbody>
            </table>
            <table>
                <tbody>
                    <tr>
                        <td><h3>ver 1.0.0</h3></td>
                    </tr>
                    <tr>
                        <td>アプリケーションをリリースしました。</td>
                    </tr>
                    <tr>
                        <td><br /></td>
                    </tr>
                </tbody>
            </table>
        </section>
    );
}

export default Terms;